import gql from 'graphql-tag';

export const schema = `
  completionResults{
    position
    suggestion
  }
  attributionToken,
  recentSearchResults{
    recentSearch
  }
`;

export default gql`
  query getAutocompleteSuggestions($payload: AutocompleteSuggestionsInput) {
    getAutocompleteSuggestions(payload: $payload) {
      ${schema}
    }
  }
`;
